import { Fragment } from 'react';
import { useMatch } from 'react-router';

import { DefaultLayout } from 'modules/layout/components/DefautLayout';
import { TopBannersHeightProvider } from 'modules/layout/components/TopBannersHeightProvider';
import { authRoutesConfig } from 'domains/auth/routes';
import { unsubscribeRoutesConfig } from 'domains/unsubscribe/routes';

import { Initializer } from './components/Initializer';
import { RedirectHandler } from './components/RedirectHandler';
import { Routes } from './Routes';
import { checkoutRoutesConfig } from '../domains/checkout/routes';

export const AppRouter = () => {
  const isAuthPage = Boolean(useMatch(authRoutesConfig.auth.path));
  const isUnsubscribePage = Boolean(
    useMatch(unsubscribeRoutesConfig.unsubscribe.path),
  );
  const isCheckoutPage = Boolean(useMatch(checkoutRoutesConfig.checkout.path));

  const RoutesWrapper =
    isAuthPage || isUnsubscribePage || isCheckoutPage
      ? Fragment
      : DefaultLayout;

  return (
    <>
      <Initializer />
      <RedirectHandler />
      <TopBannersHeightProvider>
        <RoutesWrapper>
          <Routes />
        </RoutesWrapper>
      </TopBannersHeightProvider>
    </>
  );
};
